import { AlertItem as ItemType } from "@ua/web-sdk/lib/remote-data/preference-center"
import React from "react"
import { ItemProps } from "./types"

const AlertItem: React.FC<ItemProps<ItemType>> = (props) => {
  return <></>
}

export default AlertItem
